import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EtiquetasGestionRoutingModule } from './etiquetas-gestion-routing.module';
import { ImportsModule } from 'src/app/modules/shared/imports/imports.module';
import { EtiquetasGestionComponent } from './components/etiquetas-gestion/etiquetas-gestion.component';
import { EtiquetasGestionService } from './services/etiquetas-gestion.service';

@NgModule({
  declarations: [EtiquetasGestionComponent],
  imports: [
    CommonModule,
    ImportsModule,
    EtiquetasGestionRoutingModule,
  ],
  providers: []
})
export class EtiquetasGestionModule { }
